









































































import BaseComponent from '@/core/base.component';
import Component from 'vue-class-component';
import { NanudaUserDto, NanudaUserListDto } from '../../../dto';
import NanudaUserService from '../../../services/nanuda-user.service';
import { BaseUser } from '@/services/shared/auth';
import { Pagination } from '@/common';

@Component({
  name: 'NanudaUserList',
})
export default class NanudaUserCreate extends BaseComponent {
  private nanudaUserList: NanudaUserDto[] = [];
  private nanudaUserSearchDto = new NanudaUserListDto();
  private nanudaUserListCount = 0;
  private selectedUser: NanudaUserDto = new NanudaUserDto(BaseUser);
  private pagination = new Pagination();

  search(isPagination?: boolean) {
    if (!isPagination) {
      this.pagination.page = 1;
    }
    this.pagination.limit = 5;
    NanudaUserService.findAll(
      this.nanudaUserSearchDto,
      this.pagination,
    ).subscribe(res => {
      if (res) {
        this.nanudaUserList = res.data.items;
        this.nanudaUserListCount = res.data.totalCount;
      }
    });
  }

  clearOut() {
    this.pagination.page = 1;
    this.nanudaUserSearchDto = new NanudaUserListDto();
    this.search();
  }

  cancelSelection() {
    this.selectedUser = new NanudaUserDto(BaseUser);
    this.clearOut();
  }

  paginateSearch() {
    this.search(true);
  }

  // 사용자 추가
  selectUser(user: NanudaUserDto) {
    this.selectedUser = user;
  }

  findNanudaUser() {
    if (this.selectedUser) {
      this.$root.$emit('select_nanuda_user', this.selectedUser);
    }
  }

  created() {
    this.search();
  }

  mounted() {
    this.$root.$on('find_nanuda_user', () => {
      this.search();
    });
  }
}
